import type { SituationStep } from "../../domain/types";

/** The Situation Deck signature: a visible workflow-state track. */
export function StateTrack({ steps, compact }: { steps: SituationStep[]; compact?: boolean }) {
  return (
    <ol className="flex items-center" aria-label="Workflow progress">
      {steps.map((step, i) => (
        <li key={step.key} className="flex items-center" aria-current={step.current ? "step" : undefined}>
          <div className="flex flex-col items-center gap-1" style={{ width: compact ? 58 : 72 }}>
            <span
              className={`h-2.5 w-2.5 rounded-full ${
                step.done ? "bg-success" : step.current ? "bg-primary ring-4 ring-primary/25" : "bg-border"
              }`}
              aria-hidden="true"
            />
            <span
              className={`text-center font-mono text-[9px] uppercase tracking-wide leading-tight ${
                step.done || step.current ? "text-foreground" : "text-muted-foreground"
              }`}
            >
              {step.label}
            </span>
          </div>
          {i < steps.length - 1 && (
            <span
              className={`-mt-4 h-0.5 flex-1 ${step.done ? "bg-success" : "bg-border"}`}
              style={{ minWidth: 10, width: compact ? 10 : 18 }}
              aria-hidden="true"
            />
          )}
        </li>
      ))}
    </ol>
  );
}
